import { api as supervisingApi } from "../api";
import { MetadataUnit } from "./types";

export const metadataApi = supervisingApi.injectEndpoints({
    endpoints: (build) => ({
        getMetadata: build.query<Array<MetadataUnit>, number>({
            query: (id: number) => ({
                url: `api/v1/supervising/metadata/${id}`,
            }),
        }),
    }),
});

export const { useGetMetadataQuery } = metadataApi;
